import React, { useContext } from "react";
import { Container, Row, Col } from "reactstrap";
import { LOGO, LOGO_2, LOGO_RESTAURANTE } from "../Componentes/Image";
import StoreContext from "./../Componentes/Store/Context";
export const Home = () => {
  const { usr_perfil, dataCompania } = useContext(StoreContext);
  return (
    <Row>
      <Col xs={12} className="text-center">
        {dataCompania && dataCompania.ini_fecha ? (
          <> {usr_perfil === "4" && dataCompania.com_restaurante === "1" ? <img src={LOGO_RESTAURANTE} className="cash-box-img" alt="..." /> : dataCompania.com_logo === "1" ? <img src={LOGO} className="cash-box-img" alt="..." /> : <img src={LOGO_2} className="cash-box-img" alt="..." />} </>
        ) : null}
      </Col>
    </Row>
  );
};
